import { Center, Overlay } from '@myphx-engineering/phx-design-system';

export const Loader = () => {
    return (
        <Center>
            <Overlay loader fullScreen visible />
        </Center>
    );
};
